<template>
    <date-range-picker
            ref="picker"
            :locale-data="{ firstDay: 1, format: 'd. m. yyyy' }"
            :ranges="false"
            :autoApply="false"
            v-model="dateRange"
            @update="setFilter"
    >
        <template #input="picker">
            <div class="flex py-1 px-2 text-xs bg-gray-300 rounded-full">
                <div v-if="picker.startDate && picker.endDate">
                    {{ picker.startDate.toLocaleDateString() }} - {{ picker.endDate.toLocaleDateString() }}
                </div>
                <div v-else class="italic">časově neomezeno</div>
                <button v-if="picker.startDate && picker.endDate" role="button" class="ml-2 pl-1 border-l border-gray-400 outline-none" @click.stop="unsetFilter">
                    <icon name="x"/>
                </button>
            </div>
        </template>
    </date-range-picker>
</template>

<script>
import DateRangePicker from 'vue2-daterange-picker';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
export default {
    components: { DateRangePicker },
    data() {
        return {
            dateRange: {},
            filter: 'filter[date_between]',
        }
    },
    methods: {
        setFilter() {
            Uri().addQuery(this.filter, this.dateRangeToString()).redirect();
        },
        unsetFilter() {
            Uri().removeQuery(this.filter).redirect();
        },
        dateRangeToString() {
            let startDate  = this.dateRange.startDate.toISOString().split('T')[0];
            let endDate  = this.dateRange.endDate.toISOString().split('T')[0];
            return `${startDate},${endDate}`;
        },
        dateRangeFromString(string) {
            return {
                startDate: new Date(string.split(',')[0]),
                endDate: new Date(string.split(',')[1])
            }
        }
    },

    mounted() {
        if (Uri().hasQuery(this.filter)) {
            this.dateRange = this.dateRangeFromString(Uri().getQuery(this.filter));
        }
    }
}
</script>

<style lang="scss" scoped>
    .vue-daterange-picker ::v-deep .reportrange-text {
        padding: 0;
        border: none;
        background: transparent;
    }
</style>
